import { UsageFeatureProps } from '@micro-frontend-react/employee-experience/lib/UsageTelemetry';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useDynamicReducer } from '@micro-frontend-react/employee-experience/lib/useDynamicReducer';
import { useContext, useEffect } from 'react';
import { Reducer } from 'redux';
import { IEvlAppState } from '../../App.types';
import { ILetterTemplate } from '../../models/ILetterTemplate';
import { IUserProfile } from '../../models/IUserProfile';
import { requesteTemplates } from '../actions/templateActions';
import { letterTemplatesReducer, templatesInitialState } from '../reducers/templateReducer';
import { letterTemplateSagas } from '../sagas/templatesSagas';

export function useLetterTemplates(
  feature: UsageFeatureProps,
  impersonatedCompanyCode: string,
  impersonatedCostCenter: string
): [ILetterTemplate[], boolean, boolean, string | null, number] {
  useDynamicReducer(
    'templates_reducer',
    letterTemplatesReducer as Reducer,
    [letterTemplateSagas],
    false
  );

  const { dispatch, useSelector } = useContext(
    Context as React.Context<IEmployeeExperienceContext>
  );

  const { templates, hasError, errorMessage, isLoading, statusCode } = useSelector(
    (state: IEvlAppState) => state?.dynamic?.['templates_reducer'] ?? templatesInitialState
  );

  useEffect(() => {
    dispatch(requesteTemplates(feature, impersonatedCompanyCode, impersonatedCostCenter));
  }, [dispatch, impersonatedCompanyCode, impersonatedCostCenter]);

  return [templates, isLoading, hasError, errorMessage, statusCode];
}
